import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, toDisplayString as _toDisplayString, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, mergeProps as _mergeProps, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, createStaticVNode as _createStaticVNode } from "vue"
import _imports_0 from '@/assets/images/user/admin.jpg'


const _hoisted_1 = { class: "row" }
const _hoisted_2 = { class: "col-xl-4" }
const _hoisted_3 = { class: "card" }
const _hoisted_4 = { class: "card-body" }
const _hoisted_5 = { class: "row mb-2" }
const _hoisted_6 = { class: "profile-title" }
const _hoisted_7 = { class: "d-flex" }
const _hoisted_8 = {
  class: "flex-grow-1",
  style: {"margin-left":"10px"}
}
const _hoisted_9 = { class: "col-xl-8" }
const _hoisted_10 = { class: "card-body" }
const _hoisted_11 = { class: "row" }
const _hoisted_12 = { class: "col-md-4 mb-3" }
const _hoisted_13 = { class: "form-group" }
const _hoisted_14 = { class: "col-md-4 mb-3" }
const _hoisted_15 = { class: "form-group" }
const _hoisted_16 = { class: "col-md-4 mb-3" }
const _hoisted_17 = { class: "form-group mb-15 mb-sm-20 mb-md-25" }
const _hoisted_18 = {
  key: 0,
  class: "text-danger"
}
const _hoisted_19 = { class: "col-md-4 mb-3" }
const _hoisted_20 = { class: "form-group mb-15 mb-sm-20 mb-md-25" }
const _hoisted_21 = { class: "col-md-4 mb-3" }
const _hoisted_22 = { class: "form-group mb-15 mb-sm-20 mb-md-25" }
const _hoisted_23 = { class: "card-footer text-end" }
const _hoisted_24 = { class: "col-md-6" }
const _hoisted_25 = { class: "card" }
const _hoisted_26 = { class: "card-header" }
const _hoisted_27 = { class: "card-title" }
const _hoisted_28 = {
  style: {"float":"right"},
  class: "dropdown-item d-flex align-items-center"
}
const _hoisted_29 = { class: "card-body" }
const _hoisted_30 = { class: "table-responsive" }
const _hoisted_31 = { class: "table card-table table-vcenter text-nowrap" }
const _hoisted_32 = ["onClick"]
const _hoisted_33 = { class: "col-md-6" }
const _hoisted_34 = { class: "card" }
const _hoisted_35 = { class: "card-header" }
const _hoisted_36 = { class: "card-title" }
const _hoisted_37 = { style: {"float":"right"} }
const _hoisted_38 = { class: "card-body" }
const _hoisted_39 = { class: "table-responsive" }
const _hoisted_40 = { class: "table card-table table-vcenter text-nowrap" }
const _hoisted_41 = ["onClick"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Form = _resolveComponent("Form")!
  const _component_Field = _resolveComponent("Field")!
  const _component_ErrorMessage = _resolveComponent("ErrorMessage")!
  const _component_vue_tel_input = _resolveComponent("vue-tel-input")!
  const _component_Multiselect = _resolveComponent("Multiselect")!
  const _component_router_link = _resolveComponent("router-link")!
  const _component_AddRoleModal = _resolveComponent("AddRoleModal")!
  const _component_AddPointVenteModal = _resolveComponent("AddPointVenteModal")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("div", _hoisted_3, [
          _cache[4] || (_cache[4] = _createStaticVNode("<div class=\"card-header\"><h4 class=\"card-title mb-0\">Profile : <span class=\"badge badge-primary f-w-500 background-light-primary font-primary\">Actif</span></h4><div class=\"card-options\"><a class=\"card-options-collapse\" href=\"#\" data-bs-toggle=\"card-collapse\"><i class=\"fe fe-chevron-up\"></i></a><a class=\"card-options-remove\" href=\"#\" data-bs-toggle=\"card-remove\"><i class=\"fe fe-x\"></i></a></div></div>", 1)),
          _createElementVNode("div", _hoisted_4, [
            _createVNode(_component_Form, {
              ref: "passForm",
              onSubmit: _ctx.editUserPass,
              "validation-schema": _ctx.passSchema
            }, {
              default: _withCtx(() => [
                _createElementVNode("div", _hoisted_5, [
                  _createElementVNode("div", _hoisted_6, [
                    _createElementVNode("div", _hoisted_7, [
                      _cache[3] || (_cache[3] = _createElementVNode("img", {
                        class: "img-70 rounded-circle",
                        alt: "",
                        src: _imports_0
                      }, null, -1)),
                      _createElementVNode("div", _hoisted_8, [
                        _createElementVNode("h4", null, _toDisplayString(_ctx.user?.nom) + " " + _toDisplayString(_ctx.user?.prenom), 1),
                        _createElementVNode("p", null, _toDisplayString(_ctx.user?.email), 1)
                      ])
                    ])
                  ])
                ])
              ]),
              _: 1
            }, 8, ["onSubmit", "validation-schema"])
          ])
        ])
      ]),
      _createElementVNode("div", _hoisted_9, [
        _createVNode(_component_Form, {
          class: "card",
          ref: "userForm",
          onSubmit: _ctx.editUser,
          "validation-schema": _ctx.userSchema,
          "initial-values": _ctx.userForm
        }, {
          default: _withCtx(() => [
            _cache[12] || (_cache[12] = _createElementVNode("div", { class: "card-header" }, [
              _createElementVNode("h4", { class: "card-title mb-0" }, "Modifier les informations"),
              _createElementVNode("div", { class: "card-options" }, [
                _createElementVNode("a", {
                  class: "card-options-collapse",
                  href: "#",
                  "data-bs-toggle": "card-collapse"
                }, [
                  _createElementVNode("i", { class: "fe fe-chevron-up" })
                ]),
                _createElementVNode("a", {
                  class: "card-options-remove",
                  href: "#",
                  "data-bs-toggle": "card-remove"
                }, [
                  _createElementVNode("i", { class: "fe fe-x" })
                ])
              ])
            ], -1)),
            _createElementVNode("div", _hoisted_10, [
              _createElementVNode("div", _hoisted_11, [
                _createElementVNode("div", _hoisted_12, [
                  _createElementVNode("div", _hoisted_13, [
                    _cache[5] || (_cache[5] = _createElementVNode("label", { class: "d-block text-black fw-semibold" }, [
                      _createTextVNode("Nom "),
                      _createElementVNode("span", { class: "text-danger" }, "*")
                    ], -1)),
                    _createVNode(_component_Field, {
                      name: "nom",
                      type: "text",
                      class: "form-control",
                      placeholder: "Entrer le nom"
                    }),
                    _createVNode(_component_ErrorMessage, {
                      name: "nom",
                      class: "text-danger"
                    })
                  ])
                ]),
                _createElementVNode("div", _hoisted_14, [
                  _createElementVNode("div", _hoisted_15, [
                    _cache[6] || (_cache[6] = _createElementVNode("label", { class: "d-block text-black fw-semibold" }, [
                      _createTextVNode("Prénom "),
                      _createElementVNode("span", { class: "text-danger" }, "*")
                    ], -1)),
                    _createVNode(_component_Field, {
                      name: "prenom",
                      type: "text",
                      class: "form-control",
                      placeholder: "Entrer le prénom"
                    }),
                    _createVNode(_component_ErrorMessage, {
                      name: "prenom",
                      class: "text-danger"
                    })
                  ])
                ]),
                _createElementVNode("div", _hoisted_16, [
                  _createElementVNode("div", _hoisted_17, [
                    _cache[7] || (_cache[7] = _createElementVNode("label", { class: "d-block text-black fw-semibold mb-10" }, [
                      _createTextVNode("Téléphone "),
                      _createElementVNode("span", { class: "text-danger" }, "*")
                    ], -1)),
                    _createVNode(_component_Field, {
                      name: "telephone",
                      modelValue: _ctx.telephone,
                      "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.telephone) = $event))
                    }, {
                      default: _withCtx(({ field }) => [
                        _createVNode(_component_vue_tel_input, _mergeProps({
                          placeholder: "Entrer le numéro de téléphone",
                          modelValue: field.value,
                          "onUpdate:modelValue": ($event: any) => ((field.value) = $event)
                        }, field, {
                          defaultCountry: "BJ",
                          mode: "international",
                          onValidate: _ctx.validate,
                          class: "shadow-none fs-md-15 text-black py-2"
                        }), null, 16, ["modelValue", "onUpdate:modelValue", "onValidate"])
                      ]),
                      _: 1
                    }, 8, ["modelValue"]),
                    (!_ctx.validPhone)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_18, "Veuillez entrer un numéro correct"))
                      : _createCommentVNode("", true),
                    _createVNode(_component_ErrorMessage, {
                      name: "telephone",
                      class: "text-danger"
                    })
                  ])
                ]),
                _createElementVNode("div", _hoisted_19, [
                  _createElementVNode("div", _hoisted_20, [
                    _cache[8] || (_cache[8] = _createElementVNode("label", { class: "d-block text-black fw-semibold mb-10" }, [
                      _createTextVNode("Email "),
                      _createElementVNode("span", { class: "text-danger" }, "*")
                    ], -1)),
                    _createVNode(_component_Field, {
                      type: "email",
                      class: "form-control shadow-none fs-md-15 text-black",
                      placeholder: "Entrer l'email",
                      name: "email"
                    }),
                    _createVNode(_component_ErrorMessage, {
                      name: "email",
                      class: "text-danger"
                    })
                  ])
                ]),
                _createElementVNode("div", _hoisted_21, [
                  _createElementVNode("div", _hoisted_22, [
                    _cache[9] || (_cache[9] = _createElementVNode("label", { class: "d-block text-black fw-semibold mb-10" }, [
                      _createTextVNode("Sexe "),
                      _createElementVNode("span", { class: "text-danger" }, "*")
                    ], -1)),
                    _createVNode(_component_Field, {
                      name: "sexe",
                      type: "text"
                    }, {
                      default: _withCtx(({ field }) => [
                        _createVNode(_component_Multiselect, _mergeProps({
                          modelValue: field.value,
                          "onUpdate:modelValue": ($event: any) => ((field.value) = $event)
                        }, field, {
                          options: ['Masculin', 'Féminin'],
                          "close-on-select": true,
                          "clear-on-select": false,
                          placeholder: "Sélectionner le sexe"
                        }), null, 16, ["modelValue", "onUpdate:modelValue"])
                      ]),
                      _: 1
                    }),
                    _createVNode(_component_ErrorMessage, {
                      name: "sexe",
                      class: "text-danger"
                    })
                  ])
                ])
              ])
            ]),
            _createElementVNode("div", _hoisted_23, [
              _cache[11] || (_cache[11] = _createElementVNode("button", {
                class: "btn btn-primary text-black me-3",
                type: "submit"
              }, "Modifier un utilisateur", -1)),
              _createVNode(_component_router_link, {
                to: "/utilisateurs/liste-utilisateur",
                class: "btn btn-danger"
              }, {
                default: _withCtx(() => _cache[10] || (_cache[10] = [
                  _createElementVNode("i", { class: "fa fa-trash-o lh-1 me-1 position-relative top-2" }, null, -1),
                  _createTextVNode("Annuler")
                ])),
                _: 1
              })
            ])
          ]),
          _: 1
        }, 8, ["onSubmit", "validation-schema", "initial-values"])
      ]),
      _createElementVNode("div", _hoisted_24, [
        _createElementVNode("div", _hoisted_25, [
          _createElementVNode("div", _hoisted_26, [
            _createElementVNode("div", _hoisted_27, [
              _createElementVNode("h4", null, [
                _cache[14] || (_cache[14] = _createTextVNode("Rôles ")),
                _createElementVNode("h5", _hoisted_28, [
                  _createElementVNode("a", {
                    class: "btn btn-primary btn-sm text-black mt-3",
                    href: "#",
                    "data-bs-toggle": "modal",
                    "data-bs-target": "#AddRoleModal",
                    onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.openAddRoleModal(_ctx.user)))
                  }, _cache[13] || (_cache[13] = [
                    _createElementVNode("i", { class: "fa fa-lock lh-2 me-8 position-relative top-1" }, null, -1),
                    _createTextVNode(" Ajouter un rôle ")
                  ]))
                ])
              ])
            ])
          ]),
          _createElementVNode("div", _hoisted_29, [
            _createElementVNode("div", _hoisted_30, [
              _createElementVNode("table", _hoisted_31, [
                _cache[16] || (_cache[16] = _createElementVNode("thead", null, [
                  _createElementVNode("tr", null, [
                    _createElementVNode("th", null, "Description"),
                    _createElementVNode("th", null, "Date d'affectation"),
                    _createElementVNode("th", null, "Actions")
                  ])
                ], -1)),
                _createElementVNode("tbody", null, [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.userData?.userRoles, (rle, index) => {
                    return (_openBlock(), _createElementBlock("tr", { key: index }, [
                      _createElementVNode("td", null, _toDisplayString(rle?.role?.description), 1),
                      _createElementVNode("td", null, _toDisplayString(_ctx.format_date(rle?.dateAffectation)), 1),
                      _createElementVNode("td", null, [
                        (_ctx.userData?.userRoles?.length > 1)
                          ? (_openBlock(), _createElementBlock("a", {
                              key: 0,
                              class: "btn btn-danger btn-sm",
                              onClick: ($event: any) => (_ctx.suppRole(rle.id))
                            }, _cache[15] || (_cache[15] = [
                              _createElementVNode("i", { class: "fa fa-trash" }, null, -1),
                              _createTextVNode(" Supprimer")
                            ]), 8, _hoisted_32))
                          : _createCommentVNode("", true)
                      ])
                    ]))
                  }), 128))
                ])
              ])
            ])
          ])
        ])
      ]),
      _createElementVNode("div", _hoisted_33, [
        _createElementVNode("div", _hoisted_34, [
          _createElementVNode("div", _hoisted_35, [
            _createElementVNode("div", _hoisted_36, [
              _createElementVNode("h4", null, [
                _cache[18] || (_cache[18] = _createTextVNode("Points de vente ")),
                _createElementVNode("h5", _hoisted_37, [
                  _createElementVNode("a", {
                    class: "btn btn-primary btn-sm text-black mt-3",
                    href: "#",
                    "data-bs-toggle": "modal",
                    "data-bs-target": "#AddPointVenteModal",
                    onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.openAddPointVenteModal(_ctx.user)))
                  }, _cache[17] || (_cache[17] = [
                    _createElementVNode("i", { class: "fa fa-lock lh-2 me-8 position-relative top-1" }, null, -1),
                    _createTextVNode(" Ajouter un point de vente ")
                  ]))
                ])
              ])
            ])
          ]),
          _createElementVNode("div", _hoisted_38, [
            _createElementVNode("div", _hoisted_39, [
              _createElementVNode("table", _hoisted_40, [
                _cache[20] || (_cache[20] = _createElementVNode("thead", null, [
                  _createElementVNode("tr", null, [
                    _createElementVNode("th", null, "Nom Point Vente"),
                    _createElementVNode("th", null, "Date"),
                    _createElementVNode("th", null, "Actions")
                  ])
                ], -1)),
                _createElementVNode("tbody", null, [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.user?.userpointventes || [], (pv, index) => {
                    return (_openBlock(), _createElementBlock("tr", { key: index }, [
                      _createElementVNode("td", null, _toDisplayString(pv?.pointvente?.nomPointVente), 1),
                      _createElementVNode("td", null, _toDisplayString(_ctx.format_date(pv?.createdAt)), 1),
                      _createElementVNode("td", null, [
                        (index > 0)
                          ? (_openBlock(), _createElementBlock("a", {
                              key: 0,
                              class: "btn btn-danger btn-sm",
                              onClick: ($event: any) => (_ctx.suppPointVente(pv.id))
                            }, _cache[19] || (_cache[19] = [
                              _createElementVNode("i", { class: "fa fa-trash" }, null, -1),
                              _createTextVNode(" Supprimer")
                            ]), 8, _hoisted_41))
                          : _createCommentVNode("", true)
                      ])
                    ]))
                  }), 128))
                ])
              ])
            ])
          ])
        ])
      ])
    ]),
    _createVNode(_component_AddRoleModal, {
      selectedUser: _ctx.selectedUser,
      onClose: _ctx.reloadUserData,
      onGetAllUsers: _ctx.reloadUserData
    }, null, 8, ["selectedUser", "onClose", "onGetAllUsers"]),
    _createVNode(_component_AddPointVenteModal, {
      selectedUser: _ctx.selectedUser,
      onClose: _ctx.reloadUserData,
      onGetAllUsers: _ctx.reloadUserData
    }, null, 8, ["selectedUser", "onClose", "onGetAllUsers"])
  ], 64))
}